import { render, staticRenderFns } from "./personal_data_step.vue?vue&type=template&id=70d8bddf&scoped=true"
import script from "./personal_data_step.vue?vue&type=script&lang=js"
export * from "./personal_data_step.vue?vue&type=script&lang=js"
import style0 from "./personal_data_step.vue?vue&type=style&index=0&id=70d8bddf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d8bddf",
  null
  
)

export default component.exports